<template>
  <div id="app">
    <app-header></app-header>
    <router-view />
    <app-footer></app-footer>
  </div>
</template>


<script>
import Nav from './components/Nav.vue'
import Footer from './components/Footer.vue'
import { Auth } from '@aws-amplify/auth'
import AmplifyStore from '@/store/store'

export default {
  name: 'app',
  components: {
    'app-header': Nav,
    'app-footer': Footer
  },
  async mounted() {
    // Check for authenticated user on app mount
    try {
      const user = await Auth.currentAuthenticatedUser()
      if (user && user.signInUserSession) {
        AmplifyStore.commit('setUser', user)
      }
    } catch (err) {
      console.log('No authenticated user found:', err)
      AmplifyStore.commit('setUser', null)
    }
  }
}
</script>

